module.exports = __webpack_public_path__ + "img/quality-staff.9d21806f.png";